import React from 'react';

import { OneColumn } from 'components/page';
import { TituloAlert, TituloFilter, TituloGrid, TituloRelatorio } from 'pages/financeiro/titulo/components/';
import { usePermissionsContext } from 'context/PermissionsContext';

export function TituloListComp() {
    const { hasPermission } = usePermissionsContext();

    return (
        <OneColumn title="Consulta de Títulos" extraContent={<TituloAlert />}>
            <TituloFilter />

            {hasPermission(['FINANCEIRO_TITULO_EXPORTAR']) && <TituloRelatorio />}

            <TituloGrid />
        </OneColumn>
    );
}
